import styled, { css } from 'styled-components';

export const Container = styled.button<{ $selecionado: boolean }>`
  display: flex;
  flex-direction: column;
  align-self: center;

  height: 100%;
  width: 100%;

  gap: ${({ theme }) => theme.spacing[2]}px;

  background: ${({ theme }) =>
    `linear-gradient(180deg, ${theme.panel.solid} 0%, #000 100%)`};

  padding: ${({ theme }) => theme.spacing[3]}px;
  border-radius: ${({ theme }) => theme.radius[3]}px;

  border: ${({ theme, $selecionado }) => {
    if ($selecionado) return css`2px solid ${theme.tokens.colors.text}`;
    return css`1px solid ${theme.colors.neutral.neutral[11]}`;
  }};

  cursor: pointer;
`;
